module.exports = {
      id: "video-outline-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#video-outline",
      toString: function () {
        return this.url;
      }
    }